var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { Breakpoints } from '../../constants';
var iconSizes = {
    xxs: 20,
    xs: 30,
    s: 40,
    m: 50,
    l: 85,
    xl: 100,
};
var StyledIcon = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media only screen and (max-width: ", "px) {\n    width: ", "px;\n  }\n\n  @media only screen and (min-width: ", "px) {\n    width: ", "px;\n  }\n\n  @media only screen and (min-width: ", "px) {\n    width: ", "px;\n  }\n"], ["\n  @media only screen and (max-width: ", "px) {\n    width: ", "px;\n  }\n\n  @media only screen and (min-width: ", "px) {\n    width: ", "px;\n  }\n\n  @media only screen and (min-width: ", "px) {\n    width: ", "px;\n  }\n"])), Breakpoints.TABLET, function (_a) {
    var size = _a.size;
    return (size ? "".concat(iconSizes[size]) : "".concat(iconSizes.m));
}, Breakpoints.TABLET, function (_a) {
    var size = _a.size;
    return (size ? "".concat(iconSizes[size]) : "".concat(iconSizes.m));
}, Breakpoints.DESKTOP, function (_a) {
    var size = _a.size;
    return (size ? "".concat(iconSizes[size]) : "".concat(iconSizes.m));
});
export var Icon = function (_a) {
    var size = _a.size, src = _a.src;
    return _jsx(StyledIcon, { src: src, size: size }, void 0);
};
var templateObject_1;
//# sourceMappingURL=Icon.js.map